var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bi-control',{attrs:{"query-info-url":"/RealEstate/Report/GetLandparcelQueryInfo","tree-url":"/RealEstate/Report/GetTenants","preview-url":"/RealEstate/Report/LandparcelBIResult","download-url":"/RealEstate/Report/LandparcelBIExcel"}})}
var staticRenderFns = []

export { render, staticRenderFns }